export default __webpack_public_path__ + "static/media/partner.b5b77f7e.jpg";